import compactArrayUtil from 'utils/array/compact'

export default function splitStringWithParenthesisIntoTwoLinesStringUtil (input) {
  const splitIndex = input.indexOf('(')

  if (splitIndex === -1) {
    return [
      input
    ]
  }

  const firstLine = input.slice(0, splitIndex).trim()
  const secondLine = input.slice(splitIndex).trim()

  return compactArrayUtil([
    firstLine,
    secondLine
  ])
}
